import { DefaultState, TableFilters } from 'store/reducers/types';

export const READ_WORKED_IN_LAST_30_DAYS_FILTERS_REQUEST = 'READ_WORKED_IN_LAST_30_DAYS_FILTERS_REQUEST';
export const READ_WORKED_IN_LAST_30_DAYS_FILTERS_SUCCESS = 'READ_WORKED_IN_LAST_30_DAYS_FILTERS_SUCCESS';
export const READ_WORKED_IN_LAST_30_DAYS_FILTERS_FAILURE = 'READ_WORKED_IN_LAST_30_DAYS_FILTERS_FAILURE';

export type WorkedInLast30DaysFiltersState = DefaultState & {
  contents?: TableFilters;
};

interface ReadWorkedInLast30DaysFiltersRequest {
  type: typeof READ_WORKED_IN_LAST_30_DAYS_FILTERS_REQUEST;
};

interface ReadWorkedInLast30DaysFiltersSuccess {
  type: typeof READ_WORKED_IN_LAST_30_DAYS_FILTERS_SUCCESS,
  contents: TableFilters;
};

interface ReadWorkedInLast30DaysFiltersFailure {
  type: typeof READ_WORKED_IN_LAST_30_DAYS_FILTERS_FAILURE;
};

export type WorkedInLast30DaysFiltersActionTypes = ReadWorkedInLast30DaysFiltersRequest | ReadWorkedInLast30DaysFiltersSuccess | ReadWorkedInLast30DaysFiltersFailure;